<template>
    <div v-if="isLoading" class="loading-overlay">
        <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Assegnazione...</span>
        </div>
        <div class="loading-text">Assegnazione in corso...</div>
    </div>
    <div v-else class="table-gestore card p-3">
        <TableViewBo :columns="tableColumns" :items="questions" :pagination="pagination" :sort-field="sortField"
            :sort-direction="sortDirection" @page-change="$emit('page-change', $event)" @sort="$emit('sort', $event)"
            :show-search="false" :has-actions="false" :all-selected="allSelected" @select-all="toggleSelectAll"
            :selectable="!embedded">
            <template v-if="!embedded" #selected="{ item }">
                <input type="checkbox" :value="item.id" v-model="selectedQuestions" @change="onSelectionChange">
            </template>
            <template #id="{ item }">
                <a href="#" class="text-decoration-none" @click.prevent="$emit('open-detail', item.id)">
                    #{{ item.id }}
                </a>
            </template>
            <template #created_at="{ item }">
                <div style="text-align: center;">{{ formatDate(item.created_at) }}</div>
            </template>
            <template #expires_on="{ item }">{{ formatDate(item.expires_on) }}</template>
            <template #organization="{ item }">
                <span :title="item.organization">
                    {{ item.organization?.length > 20 ? item.organization.slice(0, 20) + '...' : item.organization }}
                </span>
            </template>
            <template #region="{ item }">
                <span :title="item.region">
                    {{ item.region?.length > 15 ? item.region.slice(0, 15) + '...' : item.region }}
                </span>
            </template>
            <template #topics="{ item }">
                <div v-for="t in item.topics" :key="t.id" class="text-truncate-ellipsis">{{ t.title }}</div>
            </template>
            <template #object="{ item }">
                <div style="text-align: left;" :title="item.object">
                    {{ item.object?.length > 20 ? item.object.slice(0, 20) + '...' : item.object }}
                </div>
            </template>
            <!--<template #articles="{ item }">
                <div :title="item.articles.map(a => a.title).join(' • ')" class="text-truncate-ellipsis">
                    {{ truncatedArticles(item.articles) }}
                </div>
            </template>-->
            <template #articles="{ item }">
                <div :title="item.articles.map(a => a.title).join(' • ')"
                    style="max-width: 100px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                    {{ truncatedArticles(item.articles) }}
                </div>
            </template>

            <!-- Stato colorato -->
            <template #state_id="{ item }">
                <div :class="['state-badge', getStateClass(item.state_id?.trim().toUpperCase())]"
                    :title="item.state_id?.trim().toUpperCase() === 'STORICO' ? getLegacyStateLabel(item.legacy_state) : ''">
                    {{ getStateDisplay(item.state_id) }}
                </div>
            </template>
            <template #publish_badge="{ item }">
                <span v-if="item.state_id?.trim().toUpperCase() === 'ASSEVERATO'" class="publish-indicator"
                    :class="formatAsseverazioneState(item).published ? 'published' : 'not-published'"
                    :title="formatAsseverazioneState(item).published ? 'Pubblicato' : 'Non pubblicato'">
                    {{ formatAsseverazioneState(item).published ? '✓' : '✕' }}
                </span>
            </template>

            <!--<template #expert="{ item }">{{ item.expert ? (item.expert.name + ' ' + item.expert.surname) : 'Non assegnato' }}</template>-->

            <template #expert="{ item }">
                <!--<div v-if="embedded || (reassignableItems[item.id] && canAssign)" class="position-relative">
                    <select class="form-select form-select-sm" v-model="selectedExperts[item.id]"
                        @change="openAssignModal(item)" :disabled="isLoading">
                        <option disabled value="">{{ isLoading ? 'Caricamento...' : 'Seleziona esperto' }}</option>
                        <option v-for="e in experts || []" :key="e?.id" :value="e?.id">
                            {{ e?.name }} {{ e?.surname }}
                        </option>
                    </select>
                </div>-->
                <!--<div v-if="embedded || (reassignableItems[item.id] && canAssign)">
                    <button class="btn btn-outline-secondary btn-sm dropdown-toggle d-flex align-items-center gap-2 full-width-dropdown"
                        type="button" data-bs-toggle="dropdown" data-bs-display="dynamic"  data-bs-boundary="viewport" aria-expanded="false">

                        <span v-if="currentExpert(item)" class="avatar-circle">
                            {{ initials(currentExpert(item)) }}
                        </span>

                        <span>
                            {{ currentExpert(item)
                                ? currentExpert(item).name + ' ' + currentExpert(item).surname
                                : 'Seleziona esperto'
                            }}
                        </span>
                    </button>
                    <ul class="dropdown-menu expert-dropdown-menu">
                        <li v-for="e in experts || []" :key="e.id">
                            <button class="dropdown-item d-flex align-items-center gap-2"  :class="{ 'active-expert': selectedExperts[item.id] === e.id }"
                                @click="selectExpert(item, e)">
                                <span class="avatar-circle">{{ initials(e) }}</span>
                                {{ e.name }} {{ e.surname }}
                            </button>
                        </li>
                    </ul>
                </div>

                <div v-if="embedded || (reassignableItems[item.id] && canAssign)" class="dropdown">

                    <button class="btn btn-outline-secondary btn-sm d-flex align-items-center gap-2 full-width-dropdown"
                        type="button" data-bs-toggle="dropdown" data-bs-display="dynamic" data-bs-boundary="viewport"
                        aria-expanded="false">


                        <span v-if="currentExpert(item)" class="avatar-circle">
                            {{ initials(currentExpert(item)) }}
                        </span>


                        <div class="d-flex flex-column text-truncate">
                            <span class="fw-bold">
                                {{ currentExpert(item)
                                    ? currentExpert(item).name + ' ' + currentExpert(item).surname
                                : 'Seleziona esperto'
                                }}
                            </span>

                            <span v-if="currentExpert(item)" class="text-muted small">
                                {{ currentExpert(item).email }}
                            </span>
                        </div>
                    </button>

                    <ul class="dropdown-menu p-2 expert-dropdown-menu">

                        <li v-for="e in experts || []" :key="e.id">
                            <button class="dropdown-item d-flex align-items-center gap-2"
                                :class="{ 'active-expert': selectedExperts[item.id] === e.id }"
                                @click="selectExpert(item, e)">
                                <span class="avatar-circle">{{ initials(e) }}</span>
                                <div class="d-flex flex-column text-truncate">
                                    <span class="fw-bold">{{ e.name }} {{ e.surname }}</span>
                                    <span class="text-muted small">{{ e.email }}</span>
                                </div>
                            </button>
                        </li>
                    </ul>
                </div>-->

                <div v-if="embedded || (reassignableItems[item.id] && canAssign) || canReassignQuestion(item)"
                    class="position-relative">
                    <select class="form-select form-select-sm shadow-sm" v-model="selectedExperts[item.id]"
                        @change="openAssignModal(item)" :disabled="isLoading">
                        <option disabled value="">
                            {{ isLoading ? 'Caricamento...' : 'Seleziona esperto' }}
                        </option>
                        <option v-for="e in expertsList || []" :key="e?.id" :value="e?.id">
                            {{ e?.surname }} {{ e?.name }}
                        </option>
                    </select>
                </div>
                <div v-else class="d-flex justify-content-center align-items-center h-100">
                    <div>{{ item.expert ? item.expert.surname + ' ' + item.expert.name : 'Non assegnato' }}</div>
                </div>
            </template>

            <template #empty>Nessun elemento trovato.</template>
        </TableViewBo>
    </div>

    <SimpleModal v-model="showConfirmModal" title="Conferma assegnazione esperto" :buttons="['Annulla', 'Assegna']"
        @chose="handleConfirmChoice">
        <div>
            Vuoi assegnare l'esperto <strong>{{ modalExpertName }}</strong> al quesito <strong>#{{ modalQuestionId
                }}</strong>?
        </div>
        <br />
    </SimpleModal>
</template>

<script>
import TableViewBo from '../../../../components/common/TableViewBo.vue';
import { STATE_CONFIG } from '../../../../utils/stateConfig';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import SimpleModal from '../../../../components/common/SimpleModal.vue';

export default {
    name: 'GestoreTable',
    components: { TableViewBo, Multiselect, SimpleModal },
    //props: ['questions', 'pagination', 'sortField', 'sortDirection', 'stateIcons', 'currentFilters', 'embedded'],
    props: {
        questions: Array,
        pagination: Object,
        sortField: String,
        sortDirection: String,
        stateIcons: Object,
        currentFilters: Object,
        embedded: {
            type: Boolean,
            default: false
        },
        canAssign: {
            type: Boolean,
            default: false
        },
        experts: { type: Array, default: () => [] },
        allExpertsNotForReply: { type: Array, default: () => [] },
        selectedExperts: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            selectedQuestions: [],
            showConfirmModal: false,
            allSelected: false,
            //selectedExperts: {},
            /**columns: [
                { key: 'selected', label: '', width: '3%' },
                { key: 'id', label: 'ID', sortable: true, width: '5%' },
                { key: 'object', label: 'OGGETTO', sortable: true, width: '20%' },
                { key: 'articles', label: 'ARTICOLI', width: '15%' },
                { key: 'organization', label: 'STAZ. APPALTANTE', sortable: true, width: '15%' },
                { key: 'region', label: 'REGIONE', sortable: true, width: '10%' },
                { key: 'created_at', label: 'DATA RICEZIONE', sortable: true, width: '10%' },
                { key: 'expires_on', label: 'DATA SCADENZA', sortable: true, width: '10%' },
                { key: 'state_id', label: 'STATO', sortable: true, width: '10%' },
                { key: 'expert', label: 'ESPERTO ASSEGNATO', width: '20%' },
            ]*/
            modalExpertId: null,
            modalQuestionId: null,
            modalExpertName: '',
            isLoading: false,
        };

    },
    watch: {
        selectedQuestions(newVal) {
            this.allSelected = newVal.length === this.questions.length && this.questions.length > 0;
        },
        /**questions() {
            this.selectedQuestions = [];
            this.allSelected = false;
        }*/
        questions: {
            immediate: true,
            handler(newQuestions) {
                this.selectedQuestions = [];
                this.allSelected = false;

                if (!this.embedded) {
                    newQuestions.forEach(q => {
                        this.selectedExperts[q.id] = q.expert ? q.expert.id : null;
                    });
                }
            }
        }
    },
    computed: {
        canShowAssignDropdown(item) {
            return this.embedded
                || this.canAssign
                || this.canReassignQuestion(item);
        },
        canAssignAll() {
            return this.$root.user?.permissions?.includes('assign-question');
        },
        canAssignOne() {
            return this.$root.user?.permissions?.includes('assign-one-question');
        },

        expertsList() {
            if (this.canAssignAll) {
                return this.experts;
            }

            if (this.canAssignOne) {
                return this.allExpertsNotForReply;
            }

            return [];
        },
        canReassignQuestion() {
            return (item) => {
                const user = this.$root.user;

                const hasPermission = user.permissions?.includes('assign-one-question');

                const isAssignedToMe = item.expert && item.expert.id === user.id;

                const isReassignable = this.reassignableItems[item.id];

                return hasPermission && isAssignedToMe && isReassignable;
            };
        },
        reassignableItems() {
            return this.questions.reduce((acc, item) => {
                acc[item.id] = ['INVIATO', 'ASSEGNATO', 'IN_LAVORAZIONE'].includes(item.state_id);
                return acc;
            }, {});
        },
        tableColumns() {
            const cols = [
                { key: 'selected', label: '', width: '2%' },
                { key: 'id', label: 'ID', sortable: true, width: '4%' },
                { key: 'object', label: 'OGGETTO', sortable: true, width: '10%' },
                { key: 'articles', label: 'ARTICOLI', width: '12%' },
                { key: 'organization', label: 'STAZ. APPALTANTE', sortable: true, width: '15%' },
                { key: 'region', label: 'REGIONE', sortable: true, width: '9%' },
                { key: 'created_at', label: 'DATA RICEZIONE', sortable: true, width: '8%' },
                { key: 'expires_on', label: 'DATA SCADENZA', sortable: true, width: '8%' },
                { key: 'expert', label: 'ESPERTO', width: '39%' }
            ];

            if (!this.embedded) {
                cols.splice(8, 0, { key: 'state_id', label: 'STATO', sortable: true, width: '10%' });
                cols.splice(9, 0, {
                    key: 'publish_badge',
                    label: '',
                    sortable: false,
                    width: '1%'
                });
            }

            return cols;
        }
    },
    methods: {
        formatAsseverazioneState(question) {
            if (question.state_id !== 'ASSEVERATO') return null;
            return {
                label: 'ASSEVERATO',
                published: !!question.published,
            };

        },
        initials(user) {
            if (!user) return '';
            return `${user.name[0]}${user.surname[0]}`.toUpperCase();
        },

        currentExpert(item) {
            const id = this.selectedExperts[item.id];
            return this.expertsList?.find(e => e.id === id) || item.expert || null;
        },

        selectExpert(item, expert) {
            this.selectedExperts[item.id] = expert.id;
            this.openAssignModal(item);
        },
        goToDetail(id) {
            this.$router.push({
                name: 'questionsexpertdetail',
                params: { id },
                query: { filters: JSON.stringify(this.currentFilters) }
            })
                .then(() => {
                    console.log('Navigazione riuscita');
                })
                .catch(err => {
                    console.error('Errore nella navigazione:', err);
                });
        },
        toggleSelectAll(checked) {
            this.allSelected = checked;
            this.selectedQuestions = checked ? this.questions.map(q => q.id) : [];
            this.$emit('update:selected-questions', this.selectedQuestions);
        },
        /**getStateClass(state) {
            return STATE_CONFIG[state]?.class || '';
        },*/
        getStateDisplay(state) {
            if (!state) return '';
            const map = {
                'RISPOSTA_IN_BOZZA': 'BOZZA',
                'INVIATO': 'RICEVUTO',
                'ASSEGNATO': 'ASSEGNATO',
                'IN_LAVORAZIONE': 'IN LAVORAZIONE',
                'ASSEVERATO': 'ASSEVERATO',
                'PUBBLICATO': 'PUBBLICATO',
                'EVASO': 'EVASO',
                'ASSEGNATO A UOC': 'ASSEGNATO A UOC',
                'NON_ASSEVERATO': 'NON ASSEVERATO',
                'IN_ESAMINA_UOC': 'ASSEGNATO A UOC',
                'STORICO': 'STORICO',
            };
            return map[state.trim().toUpperCase()] || state;
        },
        getLegacyStateLabel(legacyState) {
            if (!legacyState) return '';
            const map = {
                'AssignedToUffLeg': 'Assegnato a Ufficio Legale',
                'TakenByUffLeg': 'Preso in carico da Ufficio Legale',
                'AnsweredByUffLeg': 'Evaso da Ufficio Legale',
                'RejectedByUffLeg': 'Rifiutato da Ufficio Legale',
                'RejectedByExpert': 'Rifiutato da Esperto',
                'RatedForUOC': 'Valutato per UOC',
                'AssignedToUOC': 'Assegnato a UOC',
                'AssignedToPublisher': 'Assegnato a publisher',
                'TakenByPublisher': 'Preso in carico da publisher',
                'LostAndFound': 'Lost and found',
            };
            return map[legacyState] || legacyState;
        },
        formatArticleTitle(title) {
            if (!title) return '—';

            const match = title.match(/^Art\.\s*\d+/);
            if (match) return match[0];

            if (/^Articolo\s+\d+/i.test(title)) return title;

            return title;
        },

        truncatedArticles(articles) {
            if (!articles || !articles.length) return '—';

            const formatted = articles.map(a => this.formatArticleTitle(a.title));
            if (formatted.length <= 2) {
                return formatted.join(', ');
            } else {
                return formatted.slice(0, 2).join(', ') + ', ...';
            }
        },
        onSelectionChange() {
            this.allSelected = this.selectedQuestions.length === this.questions.length;
            this.$emit('update:selected-questions', this.selectedQuestions);
        },
        formatDate(d) {
            if (!d) return '-';
            const date = new Date(d);
            return date.toLocaleDateString('it-IT');
        },
        openQuestionDetail(item) {
            this.$emit('change-view', 'QuestionDetailView', item.id);

            //this.$emit('change-view', 'QuestionDetailExpertView', item.id);
        },
        getStateClass(state) {
            switch (state) {
                case 'INVIATO': return 'state-inviato';
                case 'ASSEGNATO': return 'state-blu';
                case 'IN_LAVORAZIONE': return 'state-purple';
                case 'ASSEVERATO':
                case 'PUBBLICATO':
                case 'EVASO': return 'state-verde';
                case 'IN_ESAMINA_UOC': return 'state-inviato';
                case 'RISPOSTA_IN_BOZZA': return 'state-bozza';
                case 'NON_ASSEVERATO': return 'state-rosso';
                case 'STORICO': return 'state-storico';
                default: return '';
            }
        },
        openAssignModal(item) {
            const expertId = this.selectedExperts[item.id];
            const expert = this.expertsList.find(e => e.id === expertId);

            this.modalQuestionId = item.id;
            this.modalExpertId = expertId;
            this.modalExpertName = expert ? `${expert.name} ${expert.surname}` : '';
            this.showConfirmModal = true;
        },
        async handleConfirmChoice(choice) {
            if (choice === 'Assegna') {
                await this.assignExpert(this.modalQuestionId, this.modalExpertId);
            } else {
                if (this.embedded) {
                    this.selectedExperts[this.modalQuestionId] = null;
                } else {
                    const question = this.questions.find(
                        q => q.id === this.modalQuestionId
                    );
                    this.selectedExperts[this.modalQuestionId] =
                        question?.expert?.id || null;
                }
            }
            this.showConfirmModal = false;
        },

        async assignExpert(questionId, expertId) {
            this.isLoading = true;
            try {

                /**const question = this.questions.find(q => q.id === questionId);
                if (!question) throw new Error('Question non trovata');

                const payloadToPut = {
                    state_id: 'ASSEGNATO'
                };

                await this.$root.$api.put(`/questions/${questionId}`, payloadToPut);*/

                const payloadAssign = {
                    question_id: this.modalQuestionId,
                    legal_expert_user_id: this.modalExpertId
                };

                await this.$root.$api.post(`/questions/${this.modalQuestionId}/assign`, payloadAssign);

                if (!this.embedded) {
                    const question = this.questions.find(q => q.id === questionId);
                    const expert = this.experts.find(e => e.id === expertId);

                    if (question && expert) {
                        question.expert = expert;
                        question.state_id = 'ASSEGNATO';
                    }
                }
                this.$emit('question-assigned', this.modalQuestionId);
            } catch (err) {
                console.error(err);
            } finally {
                //this.selectedExperts[questionId] = null;
                this.showConfirmModal = false;
                this.modalQuestionId = null;
                this.modalExpertId = null;
                this.modalExpertName = '';
                this.isLoading = false;
            }
        }
    }
};
</script>

<style scoped>
.table-gestore {
    height: 100%;
    display: flex;
    flex-direction: column;
}

/* Scroll verticale solo qui */
.table-gestore .table-wrapper {
    flex: 1;
    overflow-y: auto;
}

/* Stati colorati */
.state-badge {
    padding: 0.2rem 0.5rem;
    border-radius: 0.25rem;
    display: inline-block;
    min-width: 10rem;
    text-align: center;
    font-weight: bold;
    font-size: 0.85rem;
}

.state-inviato {
    color: white;
    border: 1px solid gray;
    background-color: #ffc107;
}

.state-bozza {
    color: white;
    border: 1px solid white;
    background-color: gray;
}

.state-purple {
    color: white;
    border: 1px solid purple;
    background-color: purple;
}

.state-verde {
    color: white;
    border: 1px solid green;
    background-color: green;
}

.state-rosso {
    color: red;
    border: 1px solid red;
    background-color: #f8d7da;
}

.state-blu {
    color: white;
    border: 1px solid blue;
    background-color: blue;
}

.state-storico {
    color: white;
    border: 1px solid black;
    background-color: black;
}

.avatar-circle.empty {
    background: #fff;
    border-color: #6c757d;
    color: #6c757d;
}

.avatar-circle {
    width: 32px;
    height: 32px;
    min-width: 32px;
    min-height: 32px;

    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;

    font-size: 0.75rem;
    font-weight: 600;
    text-transform: uppercase;

    background-color: #ffffff;
    border: 1px solid #ced4da;
    color: #000000;
    flex-shrink: 0;
}

::v-deep(.multiselect__content-wrapper) {
    z-index: 2000 !important;
}

.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.8);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 2000;
}

.loading-text {
    margin-top: 1rem;
    font-weight: bold;
    color: #0d6efd;
}

.avatar-circle {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background-color: #6c757d;
    /* grigio bootstrap */
    color: #fff;
    font-weight: bold;
    font-size: 0.8rem;
    text-transform: uppercase;
}

.table-responsive>.table {
    overflow: visible;
}

.table-gestore .dropdown-menu {
    /**top: 80% !important;*/
    margin-top: var(--bs-dropdown-spacer) !important;
    min-width: 19rem;
    /**left: auto !important;*/
}

.expert-dropdown-menu {
    max-height: 200px;
    overflow-y: auto;
}

.full-width-dropdown {
    width: 100%;
    text-align: left;
    justify-content: flex-start;
}

.active-expert {
    background-color: #0d6efd;
    color: white;
}

.active-expert .expert-name {
    font-weight: bold;
}


/** .table-gestore .table-scroll-wrapper .table-row-hover {
  max-height: 300px;
  overflow-y: hidden;
  position: relative;
}*/
</style>
